export const APPLICATION_INITIALISED = 'APPLICATION/INITIALISED'
export const APPLICATION_SET_RUNNING = 'APPLICATION/RUNNING'
export const APPLICATION_SET_LOADING = 'APPLICATION/LOADING'
export const APPLICATION_SET_ERROR = 'APPLICATION/ERROR'

export const FORM_SET_ERROR = 'FORM/SET/ERROR'
export const FORM_SET_LOADING = 'FORM/SET/LOADING'
export const FORM_SET_PENDING = 'FORM/SET/PENDING'
export const FORM_SET_SUCCESS = 'FORM/SET/SUCCESS'

export const NEXT_STATE = 'NEXT/STATE'
export const PREVIOUS_STATE = 'PREVIOUS/STATE'

export const NEXT = 'NEXT'
export const PREVIOUS = 'PREVIOUS'

export const LOAD_STEP = 'LOAD/STEP'

export const SET_STORES = 'SET/STORES'
export const SET_TYPES = 'SET/TYPES'
export const SET_APPOINTMENTS = 'SET/APPOINTMENTS'
export const SET_FIELDS = 'SET/FIELDS'
export const SET_ICS_FILE = 'SET/ICS_FILE'

export const USER_SELECT_TYPE = 'USER/SELECT/TYPE'
export const USER_SELECT_CHILD = 'USER/SELECT/CHILD'
export const USER_SELECT_STORE = 'USER/SELECT/STORE'
export const USER_FILTERED_STORE = 'USER/FILTERED/STORE'
export const USER_SELECT_SLOT = 'USER/SELECT/SLOT'
export const USER_UPDATE_FORM = 'USER/UPDATE/FORM'
export const USER_SUBMIT_FORM = 'USER/SUBMIT/FORM'

export const SEND_EVENT = 'SEND/EVENT'


export const SET_MARKETING_STATE = 'SET/MARKETING/STATE'
